import { Outlet, matchPath, useLocation } from 'react-router-dom'
import { IconSprite } from '../ui/Icon'
import { MobHeader } from './MobHeader'
import { TabBar } from './TabBar'
import { useScrollMemory } from './scrollMemory'
import { useSession } from './session'
import { env } from '../config/env'
import { ReviewPrompt } from '../features/reviews'
import { FavoritesMerge } from '../features/favorites'
import { useBalanceOnPush } from '../features/account/api'

/**
 * Внутренние страницы — со своей стрелкой «назад». Шапки приложения (логотип,
 * профиль) на них нет: строку занимает навигация экрана. Шапка остаётся на
 * экранах вкладок и там, куда «назад» не ведёт.
 */
const INNER_PATHS = [
  '/catalog/:productId',
  '/catalog/:productId/stores',
  '/categories',
  '/checkout',
  '/checkout/address',
  '/checkout/pharmacy',
  '/orders/:orderId',
  '/profile',
  '/profile/edit',
  '/profile/phone',
  '/profile/addresses',
  '/profile/addresses/:addressId',
  '/profile/cards',
  '/stores',
  '/notifications',
]

/** Внутренние страницы функций за флагами: без флага там «не найдено» со своей шапкой. */
const NEWS_PATHS = ['/news', '/news/:newsId']
const FAVORITES_PATHS = ['/favorites']
const MULTI_SEARCH_PATHS = ['/search', '/search/stores']

/** Внутренние страницы с учётом включённых функций — список собирается при каждом показе. */
function innerPaths(): string[] {
  return [
    ...INNER_PATHS,
    ...(env.features.news ? NEWS_PATHS : []),
    ...(env.features.favorites ? FAVORITES_PATHS : []),
    ...(env.features.multiSearch ? MULTI_SEARCH_PATHS : []),
  ]
}

/** Каркас приложения: шапка, экран и вкладки под большим пальцем. */
export function AppShell() {
  const { pathname } = useLocation()
  const { isAuthenticated } = useSession()
  useScrollMemory()
  // Баланс на главной и во вкладке «QR» — свежий после push о кэшбэке.
  useBalanceOnPush(isAuthenticated)
  const inner = innerPaths().some((path) => matchPath(path, pathname) !== null)
  return (
    <>
      <IconSprite />
      {inner ? null : <MobHeader />}
      <main className={inner ? 'shell shell-nohead' : 'shell'}>
        <Outlet />
      </main>
      <TabBar />
      {/* Сама спрашивает оценку закрытого заказа; без флага `reviews` — ничего. */}
      <ReviewPrompt />
      {/* После входа доливает избранное гостя на сервер; без флага — ничего. */}
      <FavoritesMerge />
    </>
  )
}
